import React from "react";
import Header from "../components/portfolio/Header";
import Hero from "../components/portfolio/Hero";
import SelectedWork from "../components/portfolio/SelectedWork";
import { HomeAbout, HomeBuilt } from "../components/portfolio/HomeSections";
import Footer from "../components/portfolio/Footer";

// Homepage: what kind of designer, the selected work, the apps and plugins I built, then
// the person and one ending that is both contact and footer, on a ground of
// their own.

function Home() {
  return (
    <div className="pf-home min-h-screen w-full">
      <Header />
      <main id="main" tabIndex={-1}>
        <Hero />
        <SelectedWork />
        <HomeBuilt />
        <HomeAbout />
      </main>
      <Footer id="contact" className="pf-band" />
    </div>
  );
}

export default Home;
